export default __webpack_public_path__ + "static/media/034-tennis.b8b5d4e1.svg";